import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { CityService } from 'src/app/shared/API-Service/services/city.service';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';

@Component({
  selector: 'app-insert-city',
  templateUrl: './insert-city.component.html',
  styleUrls: ['./insert-city.component.css']
})
export class InsertCityComponent implements OnInit {
  recordtoupdate: any;
  governrate:any
  cityForm : FormGroup;
update:boolean = false;
button:boolean = false;
  constructor(private _CityService:CityService, private _Router:Router, private _FormBuilder:FormBuilder, private _GovernorateService:GovernorateService) { }

  ngOnInit(): void {
    this.getgovernorate();
    this.initiate();
    this.checkEdit();
  }


  getgovernorate(){
    this._GovernorateService.GetGovernorate().subscribe((res) => {
      this.governrate = res.data;
    },(err) => {
      console.log('their is a problem with governorates ');
    },() =>{
      console.log('completed');
    })
    }


  initiate(){
    this.cityForm = this._FormBuilder.group({
      title: ['', Validators.required],
      governorateId: ['', Validators.required],
    });
  }
  get fc() {
    return this.cityForm.controls;
  }

  checkEdit() {
    this._CityService.Data.subscribe((res) => {
      if (res != null) {
        this.cityForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
      governorateId: [res.governorateId, Validators.required],
        });
        this.update = true;
        this.recordtoupdate = res ;
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
    });
  }
  onSubmit(){
    this.button = true;
   if(this.update == false && this.cityForm.status == "VALID"){
  
    this._CityService.CreateCity(this.cityForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "Submitted Successfuly",
        showConfirmButton: false,
        timer: 1500,
      });
      this.cityForm.reset();
      this._Router.navigate(['/content/admin/ViewCity']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.cityForm.status == "VALID"){
    this.cityForm.addControl('id', new FormControl(this.recordtoupdate.id));
    this._CityService.UpdateCity(this.cityForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "updated Successfuly",
        showConfirmButton: false,
        timer: 1500,
      });
      this.cityForm.reset();
      this._Router.navigate(['/content/admin/ViewCity']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text:"Please check that all the fields are written"   
    })
    this.cityForm.markAllAsTouched();
    this.button = false;
   }
  }



  ngOnDestroy(){
    this._CityService.Data.next(null);
     }
}
